<template>
  <div class="card">
    <div class="card-body">
      <b-tabs
        justified
        nav-class="nav-tabs-custom"
        content-class="p-3 text-muted"
      >
        <b-tab active>
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="fas fa-home"></i>
            </span>
            <span class="d-none d-sm-inline-block">Informativos</span>
          </template>
          <div
            class="media p-2"
            v-for="link in linksInformativos"
            :key="link.ds_titulo"
          >
            <div class="media-body">
              <div>
                <a
                  :href="`https://uniweb.unicampo.coop.br/uniweb/${link.ds_caminho
                    .replace('~/', '')
                    .replace('~\\', '')
                    .replace(/\\/g, '/')}`"
                  target="_blank"
                >
                  <h5 class="text-ceter fst-italic text-decoration-underline">
                    {{ link.ds_titulo }}
                    <i class="mdi mdi-link font-size-20"></i>
                  </h5>
                </a>
              </div>
            </div>
          </div>
        </b-tab>
        <b-tab>
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="fas fa-home"></i>
            </span>
            <span class="d-none d-sm-inline-block">Documentos</span>
          </template>
          <div
            class="media p-2"
            v-for="link in linksDocumentos"
            :key="link.ds_titulo"
          >
            <div class="media-body">
              <div>
                <a
                  :href="`https://uniweb.unicampo.coop.br/uniweb/${link.ds_caminho
                    .replace('~/', '')
                    .replace('~\\', '')
                    .replace(/\\/g, '/')}`"
                  target="_blank"
                >
                  <h5 class="text-ceter fst-italic text-decoration-underline">
                    {{ link.ds_titulo }}
                    <i class="mdi mdi-link font-size-20"></i>
                  </h5>
                </a>
              </div>
            </div>
          </div>
        </b-tab>
        <b-tab>
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="fas fa-home"></i>
            </span>
            <span class="d-none d-sm-inline-block">Manuais</span>
          </template>
          <div
            class="media p-2"
            v-for="link in linksManuais"
            :key="link.ds_titulo"
          >
            <div class="media-body">
              <div>
                <a
                  :href="`https://uniweb.unicampo.coop.br/uniweb/${link.ds_caminho
                    .replace('~/', '')
                    .replace('~\\', '')
                    .replace(/\\/g, '/')}`"
                  target="_blank"
                >
                  <h5 class="text-ceter fst-italic text-decoration-underline">
                    {{ link.ds_titulo }}
                    <i class="mdi mdi-link font-size-20"></i>
                  </h5>
                </a>
              </div>
            </div>
          </div>
        </b-tab>
        <b-tab>
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="fas fa-home"></i>
            </span>
            <span class="d-none d-sm-inline-block"
              >Transporte de Produtos Perigosos</span
            >
          </template>
          <div
            class="media p-2"
            v-for="link in linksTransportePerigosos"
            :key="link.ds_titulo"
          >
            <div class="media-body">
              <div>
                <a
                  :href="`https://uniweb.unicampo.coop.br/uniweb/${link.ds_caminho
                    .replace('~/', '')
                    .replace('~\\', '')
                    .replace(/\\/g, '/')}`"
                  target="_blank"
                >
                  <h5 class="text-ceter fst-italic text-decoration-underline">
                    {{ link.ds_titulo }}
                    <i class="mdi mdi-link font-size-20"></i>
                  </h5>
                </a>
              </div>
            </div>
          </div>
        </b-tab>
        <b-tab>
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="fas fa-home"></i>
            </span>
            <span class="d-none d-sm-inline-block">Outras Informações</span>
          </template>
          <div
            class="media p-2"
            v-for="link in linksOutrasInfo"
            :key="link.ds_titulo"
          >
            <div class="media-body">
              <div>
                <a
                  :href="`https://uniweb.unicampo.coop.br/uniweb/${link.ds_caminho
                    .replace('~/', '')
                    .replace('~\\', '')
                    .replace(/\\/g, '/')}`"
                  target="_blank"
                >
                  <h5 class="text-ceter fst-italic text-decoration-underline">
                    {{ link.ds_titulo }}
                    <i class="mdi mdi-link font-size-20"></i>
                  </h5>
                </a>
              </div>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      linksInformativos: [],
      linksDocumentos: [],
      linksManuais: [],
      linksTransportePerigosos: [],
      linksOutrasInfo: [],
    };
  },
  async created() {
    this.$tools.fecharMenu();
    await this.buscaInformacoes();
  },
  methods: {
    async buscaInformacoes() {
      try {
        const [informacoes] = await Promise.all([
          this.$http.get("api/suporte/informativos"),
        ]);

        const dadosOriginais = informacoes.data;

        // Agrupar os dados por tipo
        const dadosSeparados = {
          I: [],
          D: [],
          C: [],
          M: [],
          T: [],
          O: [],
        };

        const hoje = new Date(); // Obtém a data atual

        dadosOriginais.forEach((item) => {
          const tipo = item.st_tipo;

          // Verificar se o campo dt_validade existe e não está vazio
          if (item.dt_validade && item.dt_validade.trim() !== "") {
            // Verificar se a data de validade está dentro do prazo
            const dtValidade = new Date(item.dt_validade);
            if (!isNaN(dtValidade) && dtValidade >= hoje) {
              if (dadosSeparados[tipo]) {
                dadosSeparados[tipo].push(item);
              } else {
                // Se o tipo não estiver nos tipos esperados, adicione-o a um array 'outros'
                dadosSeparados.O.push(item);
              }
            }
          } else {
            // Se o campo dt_validade estiver ausente ou vazio, adicione-o ao array correspondente ao tipo
            dadosSeparados[tipo].push(item);
          }
        });
        this.linksInformativos = dadosSeparados.I;
        this.linksDocumentos = dadosSeparados.D;
        this.linksConveniosBeneficios = dadosSeparados.C;
        this.linksManuais = dadosSeparados.M;
        this.linksTransportePerigosos = dadosSeparados.T;
        this.linksOutrasInfo = dadosSeparados.O;
      } catch (error) {
        // Lida com erros, se necessário
        console.error("Erro ao buscar os contatos:", error);
      }
    },
  },
};
</script>